module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>The Row is specialized version of the Grid component whose <code>hasWrap</code> prop is\nalways <code>false</code>. It is provided for convenience and accepts the same props as the\nGrid component (except <code>hasWrap</code>).</p>\n<p>For further details see Grid.</p>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Row/README.md
// module id = 382
// module chunks = 0